import './style.css';

import React, { useState } from 'react';
import { t, useLocalization } from '../../l10n/l10n';
import { Button, Modal } from '@economic/gaudi';
import { useCurrentAgreement, useCurrentUser } from '@economic/react-app';

export default function VismaConnectCongratsDialog() {
    const loadingTexts = useLocalization(textIds);
    const agreement = useCurrentAgreement();
    const user = useCurrentUser();
    const [show, setShow] = useState(true);

    if (loadingTexts || !show) {
        return null;
    }

    if (!user.vismaConnect.showCongratulationsPopup || agreement.showGettingStarted) {
        return null;
    }

    return (
        <Modal visible={show} hideOnClickOutside={false}>
            <div className="vismaconnect-popups vismaconnect-congrats flex flex-col relative h-auto p-8">
                <h1 className="text-center font-bold my-4 mx-auto">{t`CONNECT_CONGRATULATIONS_HEADLINE`}</h1>

                <br />

                <div dangerouslySetInnerHTML={{ __html: t`CONNECT_CONGRATULATIONS_TEXTFIELD1` }}></div>

                <br />

                <p className="text-center">{t`CONNECT_CONGRATULATIONS_TEXTFIELD2`}</p>

                <Button
                    className="bg-blue transition-all duration-200 ease-in align-middle rounded-sm border border-solid border-transparent text-white cursor-pointer block h-8 mt-8 mx-auto py-0 px-4 text-center"
                    appearance="primary"
                    type="button"
                    onClick={() => setShow(false)}>
                    {t`SHARED_CONFIRM_CLOSEWINDOW`}
                </Button>
            </div>
        </Modal>
    );
}

const textIds = [
    'CONNECT_CONGRATULATIONS_HEADLINE',
    'CONNECT_CONGRATULATIONS_TEXTFIELD1',
    'CONNECT_CONGRATULATIONS_TEXTFIELD2',
    'SHARED_CONFIRM_CLOSEWINDOW',
];
